import { useHistory } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { matchPath, useLocation } from "react-router-dom";

const ErrorBoundaryWrapper = ({ children }) => {
	const history = useHistory();
	const location = useLocation();
	const dialogPaths = [
		"/training/courses",
		"/training/participants",
		"/training/certifications",
		"/training/mass-update",
		"/places",
		"/training/summary",
	];

	const isDialog = dialogPaths.some((path) =>
		matchPath(location.pathname, { path, exact: false })
	);

	const handleError = () => {
		if (!isDialog) {
			history.go(-1);
		} else {
			history.go(0);
		}
	};

	return (
		<ErrorBoundary
			onError={handleError}
			location={location}
			isDialog={isDialog}
		>
			{children}
		</ErrorBoundary>
	);
};

export default ErrorBoundaryWrapper;
